import { IDataTableColumn } from '../../dataTable/DataTable/model';

const outputDeviceColumns: IDataTableColumn<any>[] = [
  {
    name: 'Digital Output ID',
    selector: 'DigitalOutputID',
    sortable: true,
    sortFunction: (rowA: any, rowB: any): number => {
      const idA = parseInt(rowA.DigitalOutputID, 10); // Convert string to number
      const idB = parseInt(rowB.DigitalOutputID, 10); // Convert string to number
      return idA - idB; // Sort numerically
    },
  },
  {
    name: 'Digital Output',
    selector: 'DigitalOutput',
    sortable: true,
  },
  {
    name: 'Global Device ID',
    selector: 'GlobalDeviceID',
    sortable: true,
  },
  {
    name: 'Device Name',
    selector: 'DeviceName',
    sortable: true,
  },
  {
    name: 'Device Description',
    selector: 'DeviceDesc',
    sortable: true,
  },
  {
    name: 'Type',
    selector: 'Type',
    sortable: true,
  },
];

export default outputDeviceColumns;
